import Default from "./default";
import Elegant from "./elegant";
import MichinAndKellyLayout from "./m&k";
import ConfluenceSafariLayout from "./confluence";
import ModisaneLawLayout from "./modisane"; // ← when you add it
import LemaSystems from "./lema";

const layouts = {
  default: Default,
  elegant: Elegant,
  michinAndkelly: MichinAndKellyLayout,
  confluencesafari: ConfluenceSafariLayout,
  lema: LemaSystems,
  modisaneLaw: ModisaneLawLayout,
};

export const getLayout = (layoutType) => layouts[layoutType] || Default;
